import pluginDateTime from '@/utils/datetime';

export default {
  async install(Vue, options) {
    Vue.use(pluginDateTime);
  },
};
